import { render, staticRenderFns } from "./selectLimit.vue?vue&type=template&id=74cb215a&scoped=true"
import script from "./selectLimit.vue?vue&type=script&lang=js"
export * from "./selectLimit.vue?vue&type=script&lang=js"
import style0 from "./selectLimit.vue?vue&type=style&index=0&id=74cb215a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cb215a",
  null
  
)

export default component.exports